module.exports = __webpack_public_path__ + "img/Procedures_Icon_Over.0edd911d.svg";